import { render, staticRenderFns } from "./TableConsistency.vue?vue&type=template&id=6f59322c&"
import script from "./TableConsistency.vue?vue&type=script&lang=js&"
export * from "./TableConsistency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports